//App
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_PREVIOUS_PAGE = "SET_PREVIOUS_PAGE";
export const SET_NOTIS = "SET_NOTIS";
export const SET_SHOW_OPTIONS = "SET_SHOW_OPTIONS";
